<div class="container-fluid maap-root-container">
  <app-header
              (deIdChange)="updateDeIdMode($event)" 
              [deId]="deId"
              [dissableDeIdSwitch]="dissableDeIdSwitch">
  </app-header>
  <app-sidebar [deId]="deId"
               [dissableDeIdSwitch]="dissableDeIdSwitch"
               (deIdChange)="updateDeIdMode($event)">
  </app-sidebar>
  <div class="insights-content">
    <header class="standalone-page-header px-3">
      <h1 class="standalone-page-title">Enterprise Insights</h1>
    </header>
    <div class="row">
        <div class="col-12">
            <p-tabs [(value)]="activeTab" (onChange)="tabChanged($event)" class="tabViewStyle">
                <p-tablist>
                    <p-tab *ngIf="showExec" value="0">Executive</p-tab>
                    <p-tab *ngIf="showOp" value="1">Operational</p-tab>
                    <p-tab *ngIf="showMed && false" value="2">Medications</p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel *ngIf="showExec" value="0">
                        <app-executive-dashboard #executiveDashboard [deId]="deId" [lookbackPeriod]="selectedDays" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-executive-dashboard> 
                    </p-tabpanel>
                    <p-tabpanel *ngIf="showOp" value="1">
                        <app-operational-dashboard #operationalDashboard [deId]="deId" [lookbackPeriod]="selectedDays" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-operational-dashboard> 
                    </p-tabpanel>
                    <p-tabpanel *ngIf="showMed && false" value="2">
                        <app-medication-insights #MedicationInsights [deId]="deId" [lookbackPeriod]="selectedDays" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-medication-insights>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </div>
    </div>
  </div>
</div>
